import { FC, memo, useCallback } from 'react'
import { useTranslation } from '../../../hooks/locale'
import { Container, DirectoryItemsContainer } from './styles'
import { DirectoryItemTransport } from '../../../transports/directory-transport'
import DirectoryItem from './directory-item'
import { Title, TitleContainer } from '../common/styles'

interface DirectoryPageProps {
    region: string
    directoryItems: DirectoryItemTransport[]
}

const DirectorySection: FC<DirectoryPageProps> = ({ region, directoryItems }) => {
    const { t } = useTranslation()

    const capitalizeTitle = useCallback((sentence: string) => {
        return sentence
            .toLowerCase()
            .split(' ')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ')
    }, [])

    const title = `${t('directoryHeading')} ${capitalizeTitle(region)}`

    return (
        <Container id="directory">
            <TitleContainer>
                <Title>{title}</Title>
            </TitleContainer>
            <DirectoryItemsContainer>
                {directoryItems.map((data, index) => data.links.length > 0 && <DirectoryItem key={index} {...data} />)}
            </DirectoryItemsContainer>
        </Container>
    )
}

export default memo(DirectorySection)
